/* Shared variant styles for notification-like components (Alert, Toast). */

export const NOTIFICATION_VARIANTS = ['ai', 'critical', 'info', 'progress', 'success', 'warning'] as const;
export type NotificationVariant = (typeof NOTIFICATION_VARIANTS)[number];

export const ROOT_MAP = {
  ai: {
    border: '1px solid transparent',
    background: 'status/ai/surface',
  },
  critical: {
    backgroundColor: 'status/critical/bg',
    borderColor: 'status/critical/border',
  },
  info: {
    backgroundColor: 'status/info/bg',
    borderColor: 'status/info/border',
  },
  progress: {
    backgroundColor: 'status/progress/bg',
    borderColor: 'status/progress/border',
  },
  success: {
    backgroundColor: 'status/success/bg',
    borderColor: 'status/success/border',
  },
  warning: {
    backgroundColor: 'status/warning/bg',
    borderColor: 'status/warning/border',
  },
};

export const ICONS_MAP = {
  ai: 'status/ai/icon',
  critical: 'status/critical/icon',
  info: 'status/info/icon',
  progress: 'status/progress/icon',
  success: 'status/success/icon',
  warning: 'status/warning/icon',
};

export const TEXT_MAP = {
  ai: 'status/ai/text',
  critical: 'status/critical/text',
  info: 'status/info/text',
  progress: 'status/progress/text',
  success: 'status/success/text',
  warning: 'status/warning/text',
};
